(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tds-home-dual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tds-home-dual')) {
  customElements.define('tds-home-dual', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const updateCartCopy = () => {
        document.querySelectorAll('.sd-drawer .sd-empty-state__text').forEach(text => {
          if (text.textContent !== this.dataset.cartDescription) text.textContent = this.dataset.cartDescription;
        });
      };
      const observeCart = () => {
        const cart = document.querySelector('.sd-drawer');
        if (!cart) return false;
        this.cartObserver = new MutationObserver(updateCartCopy);
        this.cartObserver.observe(cart, {childList: true, subtree: true});
        updateCartCopy();
        return true;
      };
      if (!observeCart()) {
        this.cartMountObserver = new MutationObserver(() => {
          if (observeCart()) this.cartMountObserver.disconnect();
        });
        this.cartMountObserver.observe(document.body, {childList: true, subtree: true});
      }
      document.addEventListener('cart:updated', updateCartCopy, {signal});
      updateCartCopy();
      const community = this.querySelector('.tds-dual__community');
      if ('IntersectionObserver' in window && community) {
        this.communityObserver = new IntersectionObserver(entries => {
          this.dataset.communityVisible = String(entries[0].isIntersecting);
        });
        this.communityObserver.observe(community);
      } else {
        this.dataset.communityVisible = 'true';
      }
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      try {
        const saved = sessionStorage.getItem('tds-home-audience');
        if (saved === 'women' || saved === 'men') this.select(saved);
      } catch {}
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab.dataset.gender);
      }, {signal});
      this.addEventListener('keydown', event => {
        const current = event.target.closest('[role="tab"]');
        if (!current || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = Array.from(current.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
        const index = tabs.indexOf(current);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.select(tabs[next].dataset.gender);
        tabs[next].focus();
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const panel = event.target.closest('[data-panel]');
        if (panel) this.select(panel.dataset.panel);
      }, {signal});
    }
    select(gender) {
      try { sessionStorage.setItem('tds-home-audience', gender); } catch {}
      this.tabs.forEach(tab => {
        const selected = tab.dataset.gender === gender;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== gender; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.cartObserver?.disconnect();
      this.cartMountObserver?.disconnect();
      this.communityObserver?.disconnect();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tds-review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tds-review-carousel')) {
    customElements.define('tds-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.tds-review-carousel__track');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.tds-review-carousel__card');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }
      move(direction) {
        const card = this.track.querySelector('.tds-review-carousel__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateControls() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.previous.hidden = this.next.hidden = overflow < 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft > overflow - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tds-season-navigation"] && !Shopify.designMode) return;
  try {
    
try {
  const nav = document.querySelector('.tds-season-nav[data-audience]');
  if (nav) sessionStorage.setItem('tds-home-audience', nav.dataset.audience);
} catch {}

  } catch(e) { console.error(e); }
})();
})();
